import {PayloadAction, createSlice} from '@reduxjs/toolkit';

import {EStorageKeys, TItemId} from 'src/constants';
import {listenerMiddleware} from 'src/models';

import {TCatalogTariffsFilters, TTariffFilters} from './definitions';

const initialState = () => {
  const rememberedState = sessionStorage.getItem(EStorageKeys.TARIFFS_CATALOG);

  return rememberedState ? JSON.parse(rememberedState) : {};
};

type TTargetDetail = {
  detailId?: number;
  pricingId?: number | null;
};

const CATALOG_ID = 'tariffCatalog';

const tariffsCatalogSlice = createSlice({
  name: 'tariffsCatalog',
  initialState,
  reducers: {
    setCatalogFilters(state, action: PayloadAction<TCatalogTariffsFilters>) {
      const prevFilters = state[CATALOG_ID]?.filters ?? {};
      const value = {filters: {...prevFilters, ...action.payload}};

      state[CATALOG_ID] = state[CATALOG_ID] ? {...state[CATALOG_ID], ...value} : value;
    },
    setFilters(state, action: PayloadAction<{filters: TTariffFilters; id: TItemId}>) {
      const {id, filters} = action.payload;

      const value = {filters};

      state[id] = state[id] ? {...state[id], ...value} : value;
    },
    setTargetDetail(
      state,
      action: PayloadAction<{id: TItemId; detailId: TItemId; pricingId?: TItemId}>,
    ) {
      const {id, detailId, pricingId} = action.payload;

      const value = {
        targetDetail: {
          detailId: Number(detailId),
          pricingId: pricingId ? Number(pricingId) : null,
        },
      };

      state[id] = state[id] ? {...state[id], ...value} : value;
    },
    resetTargetDetail(state, action: PayloadAction<TItemId>) {
      const id = action.payload;

      state[id] = state[id] ? {...state[id], targetDetail: null} : {targetDetail: null};
    },
  },
});

export const {
  setFilters: setFiltersAction,
  setCatalogFilters: setCatalogFiltersAction,
  setTargetDetail: setTargetDetailAction,
  resetTargetDetail: resetTargetDetailAction,
} = tariffsCatalogSlice.actions;
export const selectCatalogFilters = (state: TRootState) =>
  (state.tariffsCatalog[CATALOG_ID]?.filters ?? {}) as TCatalogTariffsFilters;
export const selectFilters = (id?: TItemId) => (state: TRootState) =>
  (id ? state.tariffsCatalog[id]?.filters ?? {} : {}) as TTariffFilters;
export const selectTargetDetail = (id?: TItemId) => (state: TRootState) =>
  (id ? state.tariffsCatalog[id]?.targetDetail ?? {} : {}) as TTargetDetail;

listenerMiddleware.startListening({
  actionCreator: setFiltersAction,
  effect: (_, listenerApi) => {
    const state = listenerApi.getState().tariffsCatalog;

    sessionStorage.setItem(EStorageKeys.TARIFFS_CATALOG, JSON.stringify(state));
  },
});

listenerMiddleware.startListening({
  actionCreator: setCatalogFiltersAction,
  effect: (_, listenerApi) => {
    const state = listenerApi.getState().tariffsCatalog;

    sessionStorage.setItem(EStorageKeys.TARIFFS_CATALOG, JSON.stringify(state));
  },
});

export default tariffsCatalogSlice.reducer;
